import { clsx } from "clsx";
import { Stack } from "@/components/Stack/Stack";
import type { BlogAuthorView } from "@/utils/blog/types";

export interface BlogAuthorBlockProps {
  author: BlogAuthorView;
  variant: "row" | "card";
}

/**
 * Elena's author identity. `row` is the compact byline under the article H1
 * («Елена · карьерный консультант»); `card` is the E-E-A-T block above the
 * related rail (photo, name, credentials, «Подробнее обо мне →» to /about).
 */
export function BlogAuthorBlock({ author, variant }: BlogAuthorBlockProps) {
  const avatar = (
    <span className={clsx("blog-author-avatar", !author.photo && "blog-author-avatar-empty")}>
      {author.photo ? <img src={author.photo} alt={author.name} loading="lazy" /> : null}
    </span>
  );

  if (variant === "row") {
    return (
      <div className="blog-author-row" data-component="BlogAuthorBlock">
        {avatar}
        <span className="blog-author-rowtext">
          <b>{author.name}</b> · {author.roleShort}
        </span>
      </div>
    );
  }

  return (
    <section className="blog-author-card" data-component="BlogAuthorBlock">
      {avatar}
      <Stack gap={8}>
        <b className="blog-author-name">{author.name}</b>
        <span className="blog-author-role">{author.role}</span>
        <a
          href={author.aboutHref}
          className="blog-read-link blog-author-link"
          data-track="blog-article.author.about"
        >
          Подробнее обо мне →
        </a>
      </Stack>
    </section>
  );
}

BlogAuthorBlock.displayName = "BlogAuthorBlock";
